// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23Gdh","label":"styles_label__3ateF"};